import React, { useState, useEffect } from 'react';

const Slideshow = ({ slides, interval }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, interval);

    return () => {
      clearInterval(intervalId);
    };
  }, [slides.length, interval]);

  return (
    <div className="flex w-full h-full md:w-[600px] overflow-hidden rounded-xl">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === activeIndex ? 'active' : ''}`}
        >
          {slide}
        </div>
      ))}
    </div>
  );
};

export default Slideshow;
